import React from 'react';

// Services & Helpers
import API from 'API';

// Components
import Loader from 'components/common/Loader';
import SuperTable from 'components/common/SuperTable';
import EditLetterTemplateModal from 'components/setup/EditLetterTemplateModal';

//-----------------------------------------------------------------

class SetupLetterTemplates extends React.Component {

    constructor(props) {
        super(props);

        this.editModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.props.fns.setTitle('Letter Templates');
        this.load();
    }

    async load() {
        const templates = await API.call('letter/list-templates');
        this.setState({
            isLoading: false,
            templates
        });
    }

    async open(id) {
        await this.editModalRef.current.open({ id });
        this.load();
    }

    async add() {
        await this.editModalRef.current.open({});
        this.load();
    }

    render() {
        const { isLoading, templates } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <section className="control-panel sticky">

                <h1>Letter Templates</h1>

                <button type="button" className="ms-auto btn btn-primary" onClick={() => this.add()}>
                    Add Template
                </button>

            </section>

            <section>

                <SuperTable
                    className="letter-templates-table table table-bordered clickable mb-0"
                    rows={templates}
                    keyAccessor={t => t.id}
                    cols={{
                        name: { label: 'Name' }
                    }}
                    onClick={(t) => this.open(t.id)}
                    emptyText="No templates to show"
                />

            </section>

            <EditLetterTemplateModal
                ref={this.editModalRef}
            />

        </>);
    }
}

export default SetupLetterTemplates;
